<template>
  <div>
    <div class="item" v-for="(item, i) in list" :key="i">
      <div class="item-top">
        <div class="item-top_l">
          <img :src="icons[item.approveResult]" alt="" class="tag" />
          <!-- <img
            src="../../images/icon_daishenp.svg"
            alt=""
            v-if="item.approveResult == 'nostart'"
            class="tag"
          />
          <img
            src="../../images/icon_daishenp.svg"
            alt=""
            v-if="item.approveResult == 'nostart'"
            class="tag"
          />
          <img
            src="../../images/icon_xuanzhong.svg"
            alt=""
            v-if="item.approveResult == 'agree'"
            class="tag"
          />
          <img
            src="../../images/icon_butongg.svg"
            alt=""
            v-if="item.approveResult == 'refuse'"
            class="tag"
          /> -->
          <!-- <img :src="icons[item.approveResult]" alt="" class="tag" /> -->
          <!-- 拒绝 -->
          <span
            class="txt"
            :class="[item.approveResult == 'refuse' ? 'err' : '']"
            >{{ formatType(item) }}</span
          >
        </div>
        <div class="item-top_r">{{ item.approveTime }}</div>
      </div>
      <div class="item-user">
        <div class="user-box">
          <default-icon :types="1" v-if="item.isSuperior" />
          <template v-else>
            <template v-for="(user, k) in item.userList">
              <div class="user-item" :key="k" v-if="k < showNum">
                <img
                  class="user-item_icon"
                  :src="
                    user.headUrl ||
                    require('@/assets/image/avatar/T_unknown.png')
                  "
                />
                <span class="user-item_name">{{ user.userName }}</span>
              </div>
              <default-icon
                @click="showNum = 1000"
                :key="k"
                :types="3"
                v-if="k == showNum"
              />
            </template>
          </template>
        </div>
        <div
          class="approval"
          v-if="
            pendingApproval(item.userList, 1) &&
            item.approveResult == 'underway'
          "
        >
          {{
            item.flowType == "cc"
              ? ""
              : "待审批：" + pendingApproval(item.userList, 2)
          }}
        </div>
        <opinion v-if="item.flowType == 'approve'" :list="item.userList" />
      </div>
    </div>
  </div>
</template>

<script>
// import s1 from "../../images/icon_daishenp.svg";
// import s2 from "../../images/icon_xuanzhong.svg";
// import s3 from "../../images/icon_butongg.svg";
import defaultIcon from "../../common/default-icon.vue";
import opinion from "./opinion.vue";
export default {
  name: "desc-item",
  props: {
    list: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      icons: {
        notstarted: require("@/components/images/icon_daishenp.png"), // 待审批
        waiting: require("@/components/images/icon_daishenp.png"), // 待审批
        underway: require("@/components/images/icon_daishenp.png"), // 待审批
        agree: require("@/components/images/icon_xuanzhong.png"), // 同意
        refuse: require("@/components/images/icon_butongg.png"), // 拒绝
        revoke: require("@/components/images/icon_butongg.png"), // 撤销
      },
      showNum: 4,
    };
  },
  components: { defaultIcon, opinion },
  computed: {
    status() {
      return 1;
    },
  },
  watch: {
    list: {
      handler(list) {
        console.log(list);
      },
      immediate: true,
    },
  },
  methods: {
    // 过滤待审批
    pendingApproval(list = [], type = 1) {
      if (type == 1)
        return !!list.find((item) => item.approveResult == "waiting");
      if (type == 2) {
        const arr = [];
        list.forEach((item) => {
          if (item.approveResult == "waiting" && item.userName) {
            arr.push(item.userName);
          }
        });
        return arr.join("，");
      }
    },
    formatType(item) {
      // approveType 审批类型[流程类型为审批][single:单人依次,jointly:会签,or:或签]
      const approve = {
        single: "人",
        jointly: "会签",
        or: "或签",
      };
      const { flowType, approveType, userList } = item;
      let flowTypeName = "";
      if (flowType == "approve") {
        flowTypeName = "审批人";
      } else if (flowType == "cc") {
        flowTypeName = "抄送人";
      } else {
        flowTypeName = "申请人";
      }
      return `${flowTypeName} ${
        flowType == "approve"
          ? userList.length > 1
            ? "(" + userList.length + "人" + approve[approveType] + ")"
            : ""
          : ""
      }`;
    },
  },

  created() {},
};
</script>
<style lang="less" scoped>
.item {
  width: 100%;
  min-height: 110rpx;
  box-sizing: border-box;
  padding: 0 12px;

  &:nth-last-of-type(1) {
    .item-user {
      &::before {
        display: none;
      }
    }
  }
  &-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 20px;

    &_l {
      display: flex;
      padding-left: 26px;
      position: relative;
      .tag {
        width: 18px;
        height: 18px;
        position: absolute;
        background-color: #fff;
        left: 0;
        top: 0;
        z-index: 10;
      }
      .txt {
        font-size: 15px;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: 400;
        text-align: left;
        color: #4275fd;
        &.err {
          color: #fe4f54;
        }
      }
    }
    &_r {
      font-size: 13px;
      font-family: PingFangSC, PingFangSC-Regular;
      font-weight: 400;
      text-align: left;
      color: #999999;
    }
  }
  &-user {
    min-height: 85px;
    position: relative;
    padding: 16px 26px;

    &::before {
      display: inline-block;
      content: "";
      height: calc(100% + 10px);
      border-left: 1px solid #4275fd;
      position: absolute;
      left: 9px;
      top: -2px;
      z-index: 0;
    }

    .user-box {
      display: flex;
      flex-wrap: wrap;
      .user-item {
        height: 64px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        margin-right: 12px;
        margin-bottom: 15px;
        &:nth-of-type(5n) {
          margin-right: 0;
        }
        &_icon {
          display: inline-block;
          height: 44px;
          width: 44px;
          border-radius: 50%;
        }
        &_name {
          font-size: 13px;
          font-family: PingFangSC, PingFangSC-Regular;
          font-weight: 400;
          text-align: left;
          color: #333333;
          width: 44px;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
        }
      }
    }
  }
}
.approval {
  min-height: 26px;
  font-size: 13px;
  font-family: PingFangSC, PingFangSC-Regular;
  font-weight: 400;
  line-height: 26px;
  text-align: left;
  color: #ff8948;
  white-space: wrap;
}
</style>
